module.exports = __webpack_public_path__ + "img/ball_9_transparent.14525f74.png";